<template>
  <div class="animated fadeIn">
    <div class="kt-portlet kt-portlet--mobile" style="position: relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div class="filters-container">
            <TableFilters
              v-model="filterOptions"
              style="margin-right: 45px"
              @click="refresh"
            />
            <DropdownColumns
              v-model="fields"
              class="customize"
              :export-link="exportLink"
              :export-json="exportJson"
            />
          </div>
          <div style="overflow: auto" class="mt-2">
            <b-table
              id="online-payouts-table"
              :busy.sync="isBusy"
              show-empty
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :hover="true"
              :striped="true"
              stacked="md"
              v-model="copy"
              :items="provider"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              @row-clicked="rowClicked"
              tbody-tr-class="tr-pointer"
            >
              <template v-slot:head(shop_code)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(shop_name)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(eproduct_id)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(eplayer_id)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(epayment_id)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(deposit_net_amount)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(deposit_tax_amount)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(ticket_net_amount)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(ticket_serial)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(ticket_tax_amount)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(ticket_total_amount)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(timestamp)="data">{{
                $t(data.label)
              }}</template>

              <template v-slot:cell(shop_code)="data">
                <span v-if="data.value">
                  <span v-if="data.value.to">
                    <router-link :to="`/shops/${data.value.to}`">{{
                      data.value.name
                    }}</router-link>
                  </span>
                  <span v-else>{{ data.value.name }}</span>
                </span>
              </template>

              <template v-slot:cell(shop_name)="data">
                <span v-if="data.value">
                  <span v-if="data.value.to">
                    <router-link :to="`/shops/${data.value.to}`">{{
                      data.value.name
                    }}</router-link>
                  </span>
                  <span v-else>{{ data.value.name }}</span>
                </span>
              </template>

              <template v-slot:cell(eproduct_id)="data">
                <span v-if="data.value">
                  <span v-if="data.value.to">
                    <router-link :to="`/products/${data.value.to}`">{{
                      data.value.name
                    }}</router-link>
                  </span>
                  <span v-else>{{ data.value.name }}</span>
                </span>
              </template>

              <template v-slot:cell(eplayer_id)="data">
                <span v-if="data.value">
                  <span v-if="data.value.to">
                    <router-link :to="`/players/${data.value.to}`">{{
                      data.value.name
                    }}</router-link>
                  </span>
                  <span v-else>{{ data.value.name }}</span>
                </span>
              </template>

              <template v-slot:cell(ticket_tax_amount)="data">
                <span v-if="data.value">{{ roundThousands(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(ticket_total_amount)="data">
                <span v-if="data.value">{{ roundThousands(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(ticket_net_amount)="data">
                <span v-if="data.value">{{ roundThousands(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(deposit_tax_amount)="data">
                <span v-if="data.value">{{ roundThousands(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(deposit_net_amount)="data">
                <span v-if="data.value">{{ roundThousands(data.value) }}</span>
                <span v-else>0.00</span>
              </template>

              <template v-slot:cell(timestamp)="data">
                <span>{{ mom_unix(data.value).format(tableDateLong) }}</span>
              </template>

              <template v-slot:empty="scope">
                <div class="text-center">{{ $t(scope.emptyText) }}</div>
              </template>

              <template v-slot:cell(aml)="row">
                <div v-if="row.item.hasAML" class="action-buttons">
                  <button
                    title=""
                    type="button"
                    class="btn ml-2 refresh btn-light btn-sm"
                    @click="row.toggleDetails"
                  >
                    <i class="fa fa-eye"></i>
                  </button>
                  <button
                    title=""
                    type="button"
                    class="btn ml-2 refresh btn-light btn-sm"
                    @click="printAML(row.item)"
                  >
                    <i class="fa fa-print"></i>
                  </button>
                </div>
              </template>

              <template v-slot:row-details="row">
                <b-card>
                  <div>
                    Real Beneficiary:
                    <b>{{
                      row.item.meta.extra.real_beneficiary ? "YES" : "NO"
                    }}</b>
                  </div>
                  <div>
                    Public Exposed Person:
                    <b>{{
                      row.item.meta.extra.public_person ? "YES" : "NO"
                    }}</b>
                  </div>
                  <div>
                    Related to Public Exposed Person:
                    <b>{{
                      row.item.meta.extra.related_to_public_person
                        ? "YES"
                        : "NO"
                    }}</b>
                  </div>
                  <div>
                    Terms: <b>{{ row.item.meta.extra.terms ? "YES" : "NO" }}</b>
                  </div>
                </b-card>
              </template>
            </b-table>
          </div>
          <div class="container-fluid">
            <div class="row">
              <div style="white-space: nowrap" class="my-2">
                <PaginationSelect
                  v-model="perPage"
                  :options="paginationOpts"
                  variant="light"
                  size="sm"
                />
                <span>
                  &nbsp;
                  <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                    <span slot="start">{{
                      (currentPage - 1) * perPage + 1
                    }}</span>
                    <span slot="end">{{ currentPage * perPage }}</span>
                    <span slot="total">{{ totalRows }}</span>
                  </i18n>
                </span>
                <b-button
                  size="sm"
                  @click.stop="
                    $root.$emit('bv::refresh::table', 'online-payouts-table')
                  "
                  class="ml-2 refresh"
                  variant="light"
                  :title="$t('Refresh')"
                >
                  <i class="icon-refresh"></i>
                </b-button>
              </div>
              <nav class="ml-auto mt-2">
                <b-pagination
                  size="md"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="modal-printing"
      size="xl"
      :title="$t('Print Report')"
      scrollable
      v-if="printLink"
    >
      <template slot="modal-header-close">
        <span />
      </template>
      <div class="d-block">
        <div>
          <iframe
            ref="print"
            src
            scrolling="NO"
            frameborder="0"
            class="print-iframe"
          ></iframe>
        </div>
      </div>
      <template v-slot:modal-footer="{ hide }">
        <b-button variant="secondary" @click="hide()">{{
          $t("Cancel")
        }}</b-button>
        <b-button variant="success" @click="doPrint">{{
          $t("Print")
        }}</b-button>
        <!--b-button variant="info" @click="downloadPDF">{{$t('Download PDF')}}</b-button-->
      </template>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import { errorConf } from "@/shared/notifications";
import tableMixin from "@/shared/mixins/table.mixin";
import PaginationSelect from "@/components/PaginationSelect";
import DropdownColumns from "@/components/DropdownColumns";
import TableFilters from "@/components/TableFilters";
import timeFormat from "@/shared/timeFormat";

function encode(str, encoding) {
  return escape(Buffer.from(str, encoding || "utf8").toString("base64"));
}

export default {
  name: "onlinePayouts",
  mixins: [tableMixin],
  components: {
    PaginationSelect,
    DropdownColumns,
    TableFilters,
  },
  data: function () {
    return {
      tableName: "onlinePayouts",
      filterOptions: [
        {
          field: "company_id",
          multiple: true,
          placeholder: "Company",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "companies",
          hide_select: true,
          filterOptions: ["tenant_id"],
          options: [],
          selected: [],
        },
        {
          field: "tenant_id",
          multiple: true,
          placeholder: "Tenant",
          trackBy: "eid",
          label: "brand_name",
          translate: false,
          store: "tenants",
          hide_select: true,
          filterOptions: ["shopgroup_id", "shop_id"],
          options: [],
          originalOptions: [],
          selected: [],
          postIgnore: true,
          filterOptionsBy: (data, field, fieldValue) => {
            const selected = fieldValue.map((elem) => elem.eid);
            const orig = data.list[1].originalOptions;
            if (
              selected.length == 0 &&
              data.list[1].options.length != orig.length
            ) {
              data.list[1].options = orig;
            } else if (selected.length != 0) {
              data.list[1].options = orig.filter((item) => {
                if (selected.indexOf(item.ecompany_id) > -1) {
                  return true;
                }
                return false;
              });
            }
          },
        },

        {
          field: "shopgroup_id",
          multiple: true,
          placeholder: "Shop Group",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "shopGroups",
          hide_select: true,
          options: [],
          originalOptions: [],
          selected: [],
          filterOptions: ["shop_id"],
          postIgnore: true,
          filterOptionsBy: (data, field, fieldValue) => {
            const selected = fieldValue.map((elem) => elem.eid);
            const index = 2;
            const orig = data.list[index].originalOptions;
            if (selected.length == 0) {
              data.list[index].options = orig;
            } else {
              data.list[index].options = orig.filter((item) => {
                if (selected.indexOf(item.etenant_id) > -1) {
                  return true;
                }
                return false;
              });
            }
          },
        },
        {
          field: "shop_id",
          multiple: false,
          placeholder: "Shop",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "shops",

          options: [],
          originalOptions: [],
          selected: [],
          filterOptionsBy: (data, field, fieldValue) => {
            let selectedTenants = [];
            let selectedShopGroups = [];

            if (field == "tenant_id") {
              selectedTenants = fieldValue.map((elem) => elem.eid);
            } else {
              selectedTenants = data.list[0].selected.map((elem) => elem.eid);
            }
            if (field == "shopgroup_id") {
              selectedShopGroups = fieldValue.map((elem) => elem.eshop_ids);
              if (selectedShopGroups.length) {
                selectedShopGroups = [].concat.apply([], selectedShopGroups);
              }
            } else {
              selectedShopGroups = data.list[2].selected.map(
                (elem) => elem.eshop_ids
              );
              if (selectedShopGroups.length) {
                selectedShopGroups = [].concat.apply([], selectedShopGroups);
              }
            }
            const index = 3;
            const orig = data.list[index].originalOptions;

            if (!selectedTenants.length && !selectedShopGroups.length) {
              data.list[index].options = orig;
            } else {
              let tmp = [];

              if (selectedTenants.length) {
                tmp = orig.filter((item) => {
                  if (selectedTenants.indexOf(item.etenant_id) > -1) {
                    return true;
                  }
                  return false;
                });
              }

              if (selectedShopGroups.length) {
                if (!selectedTenants.length && !selectedTenants.length) {
                  tmp = orig;
                }
                tmp = tmp.filter((item) => {
                  if (selectedShopGroups.indexOf(item.eid) > -1) {
                    return true;
                  }
                  return false;
                });
              }
              data.list[index].options = tmp;
            }
          },
        },
        {
          field: "product_id",
          multiple: true,
          placeholder: "Product",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "products",
          hide_select: true,
          options: [],
          selected: [],
        },
        {
          field: "timestamp",
          type: "date",
          opens: "right",
          timePicker: false,
          locale: {
            format: timeFormat.datePickerShort, //format of the dates displayed
            firstDay: 1, //ISO first day of week - see moment documentations for details
            showWeekNumbers: true, //show week numbers on each row of the calendar
          },
          selected: {
            startDate: moment().startOf("day"),
            endDate: moment().endOf("day"),
          },
          default: {
            startDate: moment().startOf("day"),
            endDate: moment().endOf("day"),
          },
          ranges: {
            Today: [moment().startOf("day"), moment().endOf("day")],
            Yesterday: [
              moment().subtract(1, "days").startOf("day"),
              moment().subtract(1, "days").endOf("day"),
            ],
            "This week": [
              moment().startOf("isoWeek"),
              moment().endOf("isoWeek"),
            ],
            "Last week": [
              moment().subtract(1, "week").startOf("isoWeek"),
              moment().subtract(1, "week").endOf("isoWeek"),
            ],
            "This month": [moment().startOf("month"), moment().endOf("month")],
            "Last month": [
              moment().subtract(1, "month").startOf("month"),
              moment().subtract(1, "month").endOf("month"),
            ],
            "This year": [moment().startOf("year"), moment().endOf("year")],
            "Last year": [moment().subtract(1, "year"), moment()],
          },
        },
      ],
      isBusy: false,
      sortBy: "",
      sortDesc: true,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      filterField: null,
      checkAll: false,
      copy: null,
      addLabel: "",
      fields: [
        {
          key: "shop_code",
          label: "Shop Code",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "shop_name",
          label: "Shop Name",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "eproduct_id",
          label: "Product",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "player_id",
          label: "Player ID",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "player",
          label: "Player",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "player_cnp",
          label: "Player CNP",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "payment_id",
          label: "Payment ID",
          sortable: false,
          ignore: true,
          class: "d-none",
        },
        {
          key: "ticket_serial",
          label: "Serial",
          sortable: false,
          ignore: false,
          class: "",
        },
        {
          key: "ticket_net_amount",
          label: "Ticket Net Amount",
          sortable: false,
          ignore: true,
          class: "",
        },

        {
          key: "ticket_tax_amount",
          label: "Ticket Tax Amount",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "ticket_total_amount",
          label: "Ticket Total Amount",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "deposit_net_amount",
          label: "Deposit Net Amount",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "deposit_tax_amount",
          label: "Deposit Tax Amount",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "timestamp",
          label: "Date",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "aml",
          label: "AML",
          sortable: false,
          ignore: true,
          class: "",
        },
      ],
    };
  },
  computed: {
    lang() {
      return this.$store.getters["global/defLanguage"];
    },
    exportLink() {
      const apiUrl = this.$store.getters["global/apiUrl"];
      const endpoint = this.$store.getters["onlinePayouts/endpoint"];

      return `${apiUrl}/${endpoint}?export=xls&lang=${this.lang}`;
    },
    printLink() {
      return "/print/online-payouts";
    },
    exportJson() {
      const fields = [];
      this.fields.forEach((item) => {
        if (
          typeof item.class != "undefined" &&
          item.class.indexOf("d-none") == -1
        ) {
          let key = item.key;
          if (key != "selected") {
            const efields = ["eshop_id", "eproduct_id"];

            if (efields.indexOf(key) > -1) {
              key = key.substr(1);
            }

            fields.push(key);
          }
        }
      });

      const paginationData = this.buildPagination().body;

      paginationData.fields = fields;

      return JSON.stringify(paginationData);
    },
  },
  mounted() {
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      if (modalId == "modal-printing") {
        this.unbindEvent(window, "message", this.onMessageCB);
      }
    });
  },
  methods: {
    refresh() {
      this.$root.$emit("bv::refresh::table", "online-payouts-table");
    },
    provider(ctx, callback) {
      console.log(this.fields);

      const loading = this.$loading.open({
        container: this.$refs.cnt,
      });

      const paginationData = this.buildPagination();

      const shopByID = this.$store.getters["cache/shopByID"];
      const operatorByID = this.$store.getters["cache/operatorByID"];

      Promise.all([
        this.$store.dispatch("cache/fetch", "shops").catch((e) => e),
        this.$store.dispatch("cache/fetch", "operators").catch((e) => e),
      ]).finally(() => {
        this.$store
          .dispatch("onlinePayouts/fetch", paginationData.body)
          .then((resp) => {
            this.totalRows = resp.data.total;
            resp.data.rows.forEach((item, index) => {
              if (item.eshop_id) {
                const data = shopByID(item.eshop_id);
                if (data) {
                  item.shop_name = {
                    name: data.name,
                    to: item.eshop_id,
                  };
                  item.shop_code = {
                    name: data.code,
                    to: item.eshop_id,
                  };
                } else {
                  item.shop_name = {
                    name: "N/A",
                  };
                  item.shop_code = {
                    name: "N/A",
                  };
                }
              }

              if (item.player_id) {
                item.player = `${item.player_name} ${item.player_surname}`;
              }

              if (item.eproduct_id) {
                item.eproduct_id = {
                  to: item.eproduct_id,
                  name: item.product_name,
                };
              }

              if (item.euser_id) {
                const data = operatorByID(item.euser_id);
                if (data) {
                  item.user_id = {
                    to: item.euser_id,
                    name: data.full_name,
                  };
                } else {
                  item.user_id = {
                    to: null,
                    name: item.euser_id,
                  };
                }
              }

              item.hasAML = false;

              if (item.meta) {
                try {
                  const parsed = JSON.parse(item.meta);
                  item.meta = parsed;
                  if (
                    item.meta &&
                    item.meta.extra &&
                    Object.keys(item.meta.extra).length > 0
                  ) {
                    item.hasAML = true;
                  }
                } catch (err) {
                  /**/
                }
              }
            });
            console.log(resp.data.rows);
            callback(resp.data.rows);
          })
          .catch((err) => {
            this.$bvToast.toast(
              this.$t(
                err.details && err.details.length ? err.details[0] : err.message
              ),
              errorConf(this.$t("Error"))
            );
            this.totalRows = 0;
            callback([]);
          })
          .finally(() => {
            loading.close();
          });
      });

      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    buildPagination() {
      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage,
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        paginationData.sortBy = [this.sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      const exactFields = [];
      const exactValues = [];

      this.filterOptions.forEach((item) => {
        if (item.type != "date" && item.selected.length && !item.postIgnore) {
          exactFields.push(item.field);
          if (item.trackBy) {
            const tmp = [];
            item.selected.forEach((el) => {
              tmp.push(el[item.trackBy]);
            });
            exactValues.push(tmp);
          } else {
            exactValues.push(item.selected);
          }
        } else if (item.type == "date") {
          if (item.selected.startDate && item.selected.endDate) {
            paginationData.dateField = item.field;
            paginationData.dateStart = item.selected.startDate;
            paginationData.dateEnd = item.selected.endDate;
          } else {
            paginationData.dateField = item.field;
            paginationData.dateStart = moment().startOf("day");
            paginationData.dateEnd = moment().endOf("day");
          }
        }
      });

      if (exactFields.length) {
        paginationData.exactFields = exactFields;
        paginationData.exactValues = exactValues;
      }

      return { body: paginationData };
    },
    rowClicked(item, index, event) {},
    redirect() {},
    onMessage(e) {
      let data = {};
      try {
        data = JSON.parse(e.data);
      } catch (err) {
        // noop
      }
      if (data) {
        if (data.type && data.type == "resize" && this.$refs.print) {
          this.$refs.print.height = `${data.height}px`;
        }
      }
    },
    printAML(row) {
      this.$bvModal.show("modal-printing");

      this.onMessageCB = this.onMessage.bind(this);
      this.bindEvent(window, "message", this.onMessageCB);

      this.$nextTick(() => {
        this.$refs.print.src =
          this.printLink + "?data=" + encode(JSON.stringify(row));
      });
    },
    sendMessage(msg) {
      // Make sure you are sending a string, and to stringify JSON
      this.$refs.print.contentWindow.postMessage(msg, "*");
    },
    doPrint() {
      this.sendMessage(JSON.stringify({ type: "print" }));
    },
    bindEvent(element, eventName, eventHandler) {
      if (element.addEventListener) {
        element.addEventListener(eventName, eventHandler, false);
      } else if (element.attachEvent) {
        element.attachEvent("on" + eventName, eventHandler);
      }
    },
    unbindEvent(element, eventName, eventHandler) {
      if (element.removeEventListener) {
        element.removeEventListener(eventName, eventHandler, false);
      } else if (element.attachEvent) {
        element.detachEvent("on" + eventName, eventHandler);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep #online-payouts-table th:nth-child(n + 3) {
  text-align: right;
}
::v-deep #online-payouts-table td:nth-child(n + 3) {
  text-align: right;
}

::v-deep #online-payouts-table div.action-buttons {
  display: flex;

  button {
    padding: 0.5rem;

    i {
      position: relative;
      left: 3px;
    }
  }
}
</style>
